import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Tab, Typography } from '@mui/material';

import stepTabsIcon from '../stepTabsIcon';

const StyledTab = styled(Tab)(({ theme }: any) => ({
  background: theme.palette.grey[50],
  marginRight: 0,
  border: `1px solid ${theme.palette.action.selected}`,
  boxShadow: theme.shadows[1],
  borderRadius: `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`,
  height: 76,
  maxWidth: 'unset',
  color: theme.palette.grey[700],
  [theme.breakpoints.up('sm')]: {
    minWidth: 204,
  },
  '&:focus': {
    color: theme.palette.primary.main,
  },
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    background: 'white',
  },
}));

export default function StepTab({ state, stateLabel, label, selected, value, ...a11yProps }: any) {
  return (
    <StyledTab
      icon={<Box sx={{ pr: 1 }}>{stepTabsIcon(state)}</Box>}
      iconPosition="start"
      wrapped
      selected={selected}
      value={value}
      {...a11yProps}
      label={
        <Typography
          variant="body2"
          component="span"
          sx={{
            textAlign: 'left',
            whiteSpace: 'nowrap',
          }}
        >
          <strong>{label}</strong>
          <br />
          {stateLabel}
        </Typography>
      }
    />
  );
}
